module.exports = __webpack_public_path__ + "static/media/PositiveSelfTalk.b0bfae9c.mp3";